// 法人編集履歴の法人情報・法人ユーザー情報のデータを取り出し、定義リストに渡す
import React, { memo } from 'react';
import CorporateCreateDefinitionList from './CorporateCreateDefinitionList';
import { CorporateHistoryLabel } from '../const/Corporate';
import { ResponseHistoryType, NameAndLabel } from '../../ts/types/Corporate';
interface Props {
  type: string;
  info: ResponseHistoryType;
}

const CorporateCreateHistoryDetails: React.FC<Props> = ({ type, info }) => {
  return (
    <>
      {CorporateHistoryLabel[type].map((item: NameAndLabel) => (
        <React.Fragment key={item.name}>
          <CorporateCreateDefinitionList label={item.label} value={info[item.name]} />
        </React.Fragment>
      ))}
    </>
  );
};

export default memo(CorporateCreateHistoryDetails);
